import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA manifest must be swapped BEFORE the browser captures install metadata.
// iOS Safari reads the manifest immediately on page load and caches its
// start_url for "Add to Home Screen" — so dynamic swaps inside React useEffect
// arrive too late. We swap synchronously here based on the current path.
//
// On iOS specifically, the most reliable behaviour is to REMOVE the manifest
// entirely on role pages — then iOS falls back to using the current document
// URL as the standalone start_url. Android Chrome still uses the role-specific
// manifest for the install prompt.
(function setRoleManifest() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const path = window.location.pathname || '/';
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  let manifestHref = '/manifest.json';
  let role = null;
  if (path.startsWith('/partner')) {
    manifestHref = '/manifest-partner.json';
    role = 'partner';
  } else if (path.startsWith('/agent')) {
    manifestHref = '/manifest-agent.json';
    role = 'agent';
  }

  let link = document.querySelector('link[rel="manifest"]');

  if (isIOS && role) {
    // On iOS, drop the manifest on role pages so iOS uses the document URL
    // (/partner or /agent) as the standalone start_url.
    if (link && link.parentNode) {
      link.parentNode.removeChild(link);
    }
  } else {
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    if (link.getAttribute('href') !== manifestHref) {
      link.setAttribute('href', manifestHref);
    }
  }

  try {
    if (role) localStorage.setItem('pwa_role', role);
  } catch (e) { /* private mode */ }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
